module.exports = __webpack_public_path__ + "static/img/samajuri (42).d76cd7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (42).jpg
// module id = g670
// module chunks = 0